"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var browser_tracker_1 = require("@snowplow/browser-tracker");
var browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
/**
 * Sends the page_view event and refreshes link tracking
 *
 * @param pageViewContexts - optional array of contexts that may be appended to the page_view event
 */
var enhancedPageView = function enhancedPageView(pageViewContexts) {
  (0, browser_tracker_1.trackPageView)({
    context: pageViewContexts
  });
  (0, browser_plugin_link_click_tracking_1.refreshLinkClickTracking)();
};
exports["default"] = enhancedPageView;